// src/pages/pedidos/ChatBotWhatsappCad.js
import React  from 'react';

import Input from '../../components/input/Input';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import { useMessage } from '../../contexts/geral/MessageContext';
import { useChatBotWhatsapp } from '../../contexts/pedidos/ChatBotWhatsappContext';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const ChatBotWhatsappCad = ({ show, onHide }) => {
    const { chatBotWhatsapp, setChatBotWhatsapp, updateChatBotWhatsapp } = useChatBotWhatsapp();
    const { showMessage } = useMessage();

    const handleSave = async () => {
        if (!chatBotWhatsapp.respostaAutomatica || !chatBotWhatsapp.msgEmProducao || !chatBotWhatsapp.msgProntoBuscar ||
            !chatBotWhatsapp.msgProntoLocal ||
            !chatBotWhatsapp.msgSaiuPEntrega) {
            showMessage("Todos os campos devem ser preenchidos!");
            return;
        }

        try {
            await updateChatBotWhatsapp(chatBotWhatsapp);
            onHide();
        } catch (error) {
            console.error("Erro ao salvar configuração do ChatBot WhatsApp:", error);
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} largura={'700px'} variant="cadastro" onHide={onHide}>
            <ModalHeader title="Configuração do ChatBot WhatsApp" onHide={onHide} />

            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Resposta Automática"
                            value={chatBotWhatsapp?.respostaAutomatica || ''}
                            onChange={(e) => setChatBotWhatsapp({ ...chatBotWhatsapp, respostaAutomatica: e.target.value })}
                            size={650}
                            rows={3}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <Input
                            label="Mensagem Em Produção"
                            value={chatBotWhatsapp?.msgEmProducao || ''}
                            onChange={(e) => setChatBotWhatsapp({ ...chatBotWhatsapp, msgEmProducao: e.target.value })}
                            size={650}
                            rows={2}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <Input
                            label="Mensagem Pronto para Buscar"
                            value={chatBotWhatsapp?.msgProntoBuscar || ''}
                            onChange={(e) => setChatBotWhatsapp({ ...chatBotWhatsapp, msgProntoBuscar: e.target.value })}
                            size={650}
                            rows={2}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <Input
                            label="Mensagem Pronto para Consumo no Local"
                            value={chatBotWhatsapp?.msgProntoLocal || ''}
                            onChange={(e) => setChatBotWhatsapp({ ...chatBotWhatsapp, msgProntoLocal: e.target.value })}
                            size={650}
                            rows={2}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <Input
                            label="Mensagem Saiu para Entrega"
                            value={chatBotWhatsapp?.msgSaiuPEntrega || ''}
                            onChange={(e) => setChatBotWhatsapp({ ...chatBotWhatsapp, msgSaiuPEntrega: e.target.value })}
                            size={650}
                            rows={2}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <Input
                            label="Mensagem Finalizado"
                            value={chatBotWhatsapp?.msgFinalizado || ''}
                            onChange={(e) => setChatBotWhatsapp({ ...chatBotWhatsapp, msgFinalizado: e.target.value })}
                            size={650}
                            rows={2}
                        />
                    </div>
                </form>
            </ModalBody>

            <ModalFooter>
                <ModalActions >
                    <ModalActionButton className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>
        </ModalContainer>
    );
};

export default ChatBotWhatsappCad;
